/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {
  Box, Dialog, DialogContent, DialogTitle,
  Grid,
  TextField,
  MenuItem,
  IconButton,
  Button,
  Typography,
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import {Save} from '@material-ui/icons';
import toastr from 'toastr';
import {listFieldsDatabase} from 'api-lofty';
import {searchForReadDB} from '../../util/searchParentComponent';
import {getAllReadFieldsForSumParams} from '../../util/databaseFieldsComponent';
import 'toastr/build/toastr.min.css';

const useStyle = makeStyles(() => ({
  titleArea: {
    padding: 0,
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignContent: 'center',
    alignItems: 'center',
    backgroundColor: '#242424',
    padding: '10px',
  },
  titleStyle: {
    marginLeft: '5px',
    color: 'rgba(255, 255, 255, 1)',
  },
  inputInfoContainer: {
    padding: '10px',
  },
  inputTitleInfo: {
    fontSize: '15px',
    fontWeight: 600,
    color: '#000',
  },
}));

function isNumericInput(str) {
  // Allows "-", ".", "-.", "12."
  return /^-?\d*\.?\d*$/.test(str);
}

function makeDefaultRow(isFirst) {
  return {
    op: isFirst ? undefined : '+',
    value: {kind: 'static', number: ''},
  };
}

const OPS = [
  {value: '+', label: 'Sumar (+)'},
  {value: '-', label: 'Restar (-)'},
  {value: '*', label: 'Multiplicar (×)'},
  {value: '/', label: 'Dividir (÷)'},
];

export default function ModalMathOperationsManager({
  data,
  localVariables,
  globalVariables,
  token,
  idProject,
  open,
  onClose,
}) {
  const classes = useStyle();

  const [typesOfFields, setTypesOfFields] = useState([
    {value: 'static', label: 'Estatico'},
  ]);
  const [fieldsOfDb, setFieldsOfDb] = useState([]);
  const [dbTypeVars, setDBTypeVars] = useState([]);
  const [numVars, setNumVars] = useState([]);

  const [rows, setRows] = useState([]);

  const [errorData, setErrorData] = useState([]);

  useEffect(async () => {
    try {
      if (!data) {
        return;
      }
      if (data?.attributes?.attributes?.sumInfoArray) {
        setRows(data?.attributes?.attributes?.sumInfoArray);
      } else {
        setRows([makeDefaultRow(true)]);
      }
      const nextTypes = [{value: 'static', label: 'Estatico'}];
      // Scan for possible DBs, or components
      const searchForReaderInProximity = searchForReadDB(data);
      if (searchForReaderInProximity) {
        const capturedFields = await getAllReadFieldsForSumParams(
          searchForReaderInProximity,
          token,
          idProject,
        );
        if (capturedFields?.length > 0) {
          nextTypes.push({value: 'dbfields', label: 'Campos de Base de Datos'});
          setFieldsOfDb(capturedFields);
        }
      }
      const searchBasicVars = [];
      const optionBasicLocal = localVariables.filter((variable) => (variable.type === 'number'));
      const optionBasicGlobal = globalVariables.filter((variable) => (variable.typeValue === 'number'));
      if (optionBasicLocal.length > 0) {
        for (const varNum of optionBasicLocal) {
          searchBasicVars.push({
            idVariable: varNum._id,
            value: varNum._id,
            label: varNum.label,
            typeVariable: 'local',
          });
        }
      }
      if (optionBasicGlobal.length > 0) {
        for (const varNum of optionBasicGlobal) {
          searchBasicVars.push({
            idVariable: varNum._id,
            value: varNum._id,
            label: varNum.label,
            typeVariable: 'global',
          });
        }
      }
      if (searchBasicVars.length > 0) {
        nextTypes.push({value: 'basicVars', label: 'Variables Numericas'});
        setNumVars(searchBasicVars);
      }
      const searchForVariablesWithNumberFields = [];
      const optionDataLocal = localVariables.filter((variable) => (variable.type === 'arrayDatabase' || variable.type === 'database'));
      const optionDataGlobal = globalVariables.filter((variable) => (variable.typeValue === 'arrayDatabase' || variable.typeValue === 'database'));
      if (optionDataLocal?.length > 0) {
        for (const localInfo of optionDataLocal) {
          const fieldData = await listFieldsDatabase({
            token, idProject, idDatabase: localInfo.idDatabase,
          });
          const getRespectiveFields = fieldData.data.filter((index) => (index.type === 'number'));
          if (getRespectiveFields?.length > 0) {
            searchForVariablesWithNumberFields.push({
              idVariable: localInfo._id,
              idFromDatabase: localInfo.idDatabase,
              value: localInfo._id,
              label: localInfo.label,
              respectiveFields: getRespectiveFields,
              typeVariable: 'local',
            });
          }
        }
      }
      if (optionDataGlobal?.length > 0) {
        for (const globalInfo of optionDataGlobal) {
          const fieldData = await listFieldsDatabase({
            idDatabase: globalInfo.idDatabase, token, idProject,
          });
          const getRespectiveFields = fieldData.data.filter((index) => (index.type === 'number'));
          if (getRespectiveFields?.length > 0) {
            searchForVariablesWithNumberFields.push({
              idVariable: globalInfo._id,
              idFromDatabase: globalInfo.idDatabase,
              value: globalInfo._id,
              label: globalInfo.label,
              respectiveFields: getRespectiveFields,
              typeVariable: 'global',
            });
          }
        }
      }
      if (searchForVariablesWithNumberFields.length > 0) {
        nextTypes.push({value: 'varwithfields', label: 'Variables con Campos de Base de Datos'});
        setDBTypeVars(searchForVariablesWithNumberFields);
      }
      setTypesOfFields(nextTypes);
    } catch (error) {
      // console.log(error);
    }
  }, [data]);

  const updateRow = (index, patch) => {
    setRows((prev) => {
      const next = [...prev];
      next[index] = {...next[index], ...patch};
      return next;
    });
  };

  const updateValue = (index, valuePatch) => {
    setRows((prev) => {
      const next = [...prev];
      const cur = next[index].value;
      next[index] = {...next[index], value: {...cur, ...valuePatch}};
      return next;
    });
  };

  function makeEmptyValue(kind) {
    switch (kind) {
      case 'static':
        return {kind: 'static', number: ''};

      case 'basicVars':
        return {kind: 'basicVars', idVariable: ''};

      case 'dbfields':
        return {kind: 'dbfields', idField: ''};

      case 'varwithfields':
        return {
          kind: 'varwithfields', idVariable: '', idField: '',
        };

      default:
        return {kind: 'static', number: ''};
    }
  }

  const switchValueKind = (index, kind) => {
    setRows((prev) => {
      const next = [...prev];
      next[index] = {
        ...next[index],
        value: makeEmptyValue(kind),
      };
      return next;
    });
  };

  const addRow = () => setRows((prev) => [...prev, makeDefaultRow(false)]);

  const removeRow = (index) => {
    setRows((prev) => {
      const next = prev.filter((_, i) => i !== index);
      // Ensure first row never has op
      if (next[0]) next[0] = {...next[0], op: undefined};
      return next.length ? next : [makeDefaultRow(true)];
    });
  };

  function verifyData(rows) {
    const errors = [];
    if (!Array.isArray(rows) || rows.length === 0) {
      return ['Debes agregar al menos un valor inicial.'];
    }

    const isNum = (s) => typeof s === 'string' && s.trim() !== '' && !Number.isNaN(Number(s));

    rows.forEach((row, idx) => {
      const isFirst = idx === 0;

      // Operator rules
      if (!isFirst && !row.op) {
        errors.push(`Fila ${idx + 1}: falta la operación (+, -, *, /).`);
      }

      // Value rules
      if (!row.value || !row.value.kind) {
        errors.push(`Fila ${idx + 1}: falta seleccionar el tipo de valor.`);
        return;
      }

      const v = row.value;

      switch (v.kind) {
        case 'static':
          if (!isNum(v.number)) errors.push(`Fila ${idx + 1}: número inválido o vacío.`);
          break;

        case 'basicVars':
          if (!v.idVariable) errors.push(`Fila ${idx + 1}: selecciona una variable.`);
          break;

        case 'dbfields':
          if (!v.idField) errors.push(`Fila ${idx + 1}: selecciona un campo de base de datos.`);
          break;

        case 'varwithfields':
          if (!v.idVariable) errors.push(`Fila ${idx + 1}: selecciona una variable de base de datos.`);
          if (!v.idField) errors.push(`Fila ${idx + 1}: selecciona un campo de esa variable.`);
          break;

        default:
          errors.push(`Fila ${idx + 1}: tipo de valor desconocido (${v.kind}).`);
          break;
      }
    });

    return errors;
  }

  function saveToComponent() {
    const verifyRow = verifyData(rows);
    if (verifyRow.length > 0) {
      toastr.options = {
        positionClass: 'toast-top-right',
        hideDuration: 300,
        timeOut: 6000,
      };
      toastr.clear();
      setTimeout(() => toastr.error('Error al guardar datos. Verifique los datos.'), 300);
      setErrorData(verifyRow);
    } else {
      toastr.options = {
        positionClass: 'toast-top-right',
        hideDuration: 300,
        timeOut: 6000,
      };
      toastr.clear();
      setTimeout(() => toastr.success('Se guardo la informacion exitosamente'), 300);
      setErrorData([]);
      data.addAttributes({sumInfoArray: rows});
    }
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle className={classes.titleArea}>
        <Box className={classes.titleContainer}>
          <Box className={classes.titleStyle}>
            Manejar Valores para Operacion Matematica
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent style={{background: '#242424', color: '#fff'}}>
        <Box
          component="div"
          style={{
            margin: '15px', padding: '5px', height: '400px', overflowY: 'scroll',
          }}
        >
          {errorData.length > 0 && (
            <Box
              style={{
                background: '#fff', width: '95%', padding: '10px', minHeight: '50px',
              }}
            >
              {errorData.slice(0, 6).map((e, i) => (
                <Typography key={i} variant="body2" style={{color: '#c62828'}}>
                  •
                  {' '}
                  {e}
                </Typography>
              ))}
              {errorData.length > 6 && (
              <Typography variant="body2" style={{color: '#c62828'}}>
                • …y
                {' '}
                {errorData.length - 6}
                {' '}
                más
              </Typography>
              )}
            </Box>
          )}
          <Box
            style={{background: '#fff', width: '95%', padding: '10px'}}
          >
            {rows.map((row, idx) => {
              const isFirst = idx === 0;

              return (
                <Grid container spacing={2} alignItems="center" key={idx} style={{marginBottom: 6}}>
                  {/* Operator */}
                  <Grid item xs={12} sm={2}>
                    {isFirst ? (
                      <TextField
                        label="Base"
                        value="="
                        fullWidth
                        disabled
                      />
                    ) : (
                      <TextField
                        select
                        label="Op"
                        value={row.op || '+'}
                        onChange={(e) => updateRow(idx, {op: e.target.value})}
                        fullWidth
                      >
                        {OPS.map((o) => (
                          <MenuItem key={o.value} value={o.value}>
                            {o.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    )}
                  </Grid>

                  {/* Value type */}
                  <Grid item xs={12} sm={3}>
                    <TextField
                      select
                      label="Valor"
                      value={row.value.kind}
                      onChange={(e) => switchValueKind(idx, e.target.value)}
                      fullWidth
                    >
                      {typesOfFields.map((t) => (
                        <MenuItem key={t.value} value={t.value}>
                          {t.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  {/* Value editor */}
                  <Grid item xs={12} sm={5}>
                    {row.value.kind === 'static' && (
                    <TextField
                      label="Número"
                      value={row.value.number}
                      onChange={(e) => {
                        const next = e.target.value;
                        if (isNumericInput(next)) updateValue(idx, {number: next});
                      }}
                      placeholder="e.g. 10.5"
                      fullWidth
                    />
                    )}

                    {row.value.kind === 'basicVars' && (
                    <TextField
                      select
                      label="Variable"
                      value={row.value.idVariable}
                      onChange={(e) => updateValue(idx, {idVariable: e.target.value})}
                      fullWidth
                    >
                      {numVars.map((v) => (
                        <MenuItem key={v.idVariable} value={v.idVariable}>
                          {v.label}
                          {' - '}
                          {v.typeVariable}
                        </MenuItem>
                      ))}
                    </TextField>
                    )}
                    {row.value.kind === 'dbfields' && (
                    <TextField
                      select
                      label="Campo de BD"
                      value={row.value.idField}
                      onChange={(e) => updateValue(idx, {idField: e.target.value})}
                      fullWidth
                    >
                      {fieldsOfDb.map((f) => (
                        <MenuItem key={f._id} value={f._id}>
                          {f.label || f.name}
                        </MenuItem>
                      ))}
                    </TextField>
                    )}

                    {/** VAR WITH FIELDS */}
                    {row.value.kind === 'varwithfields' && (
                    <Grid container spacing={1}>
                      <Grid item xs={6}>
                        <TextField
                          select
                          label="Variable con Campos"
                          value={row.value.idVariable}
                          onChange={(e) => {
                            // reset field (avoids invalid combos)
                            updateValue(idx, {idVariable: e.target.value, idField: ''});
                          }}
                          fullWidth
                        >
                          {dbTypeVars.map((v) => (
                            <MenuItem key={v.idVariable} value={v.idVariable}>
                              {v.label}
                              {' - '}
                              {v.typeVariable}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>

                      <Grid item xs={6}>
                        <TextField
                          select
                          label="Campo"
                          value={row.value.idField}
                          onChange={(e) => updateValue(idx, {idField: e.target.value})}
                          fullWidth
                          disabled={!row.value.idVariable}
                        >
                          {(dbTypeVars.find((v) => v.idVariable === row.value.idVariable)?.respectiveFields || [])
                            .map((f) => (
                              <MenuItem key={f._id} value={f._id}>
                                {f.label || f.name}
                              </MenuItem>
                            ))}
                        </TextField>
                      </Grid>
                    </Grid>
                    )}

                  </Grid>

                  {/* Row actions */}
                  <Grid item xs={12} sm={2} style={{display: 'flex', justifyContent: 'flex-end'}}>
                    <IconButton onClick={() => removeRow(idx)} aria-label="delete">
                      <DeleteIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              );
            })}
            <Button
              onClick={addRow}
              startIcon={<AddIcon />}
              variant="outlined"
              style={{marginTop: 8}}
            >
              Agregar
            </Button>
          </Box>
        </Box>
        <Box className={classes.buttonAreaContainer}>
          <Button
            variant="contained"
            color="secondary"
            onClick={onClose}
            className={classes.buttonStyle}
          >
            Cerrar
          </Button>
          <Button
            onClick={() => saveToComponent()}
            startIcon={<Save />}
            variant="contained"
            color="primary"
            style={{marginLeft: '10px'}}
          >
            Guardar
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
